module.exports = __webpack_public_path__ + "static/media/comment-minus.31518e22.svg";